import React from "react";
import { useTranslation } from "react-i18next";
import { TickMark } from "@egovernments/digit-ui-react-components";

let actions = [];

const getAction = (flow) => {
  switch (flow) {
    case "STAKEHOLDER": actions = []
      break;
    case "APPLY": actions = [
      'FSM_TIMELINE_PROPERTY_DETAILS',
      'FSM_GENDER_DETAILS',
      'FSM_PAYMENT_DETAILS',
      'FSM_TIMELINE_SUMMARY',
    ]
      break;
    default: actions = [
      'TL_COMMON_TR_DETAILS',
      'TL_LOCATION_AND_OWNER_DETAILS',
      'TL_DOCUMENT_DETAIL',
      'TL_COMMON_SUMMARY',
    ]
  }
}
const Timeline = ({ currentStep = 1, flow = "" }) => {
  const { t } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  getAction(flow);
  return (
    <div className="timeline-container" style={isMobile ? {} : { maxWidth: "960px", marginRight: "auto" }} >
      {actions.map((action, index, arr) => (
        <div className="timeline-checkpoint" key={index}>
          <div className="timeline-content">
            <span className={`circle ${index <= currentStep - 1 && 'active'}`}>{index < currentStep - 1 ? <TickMark /> : index + 1}</span>
            <span className="secondary-color">{t(action)}</span>
          </div>
          {index < arr.length - 1 && <span className={`line ${index < currentStep - 1 && 'active'}`}></span>}
        </div>
      ))}
    </div>
  )
}

export default Timeline; 